import { Injectable } from '@angular/core';
import { CategoryRule, CategorySetDTO, SelectedCategory } from 'src/app/cxone/dashboard/modals/category-selection-modal/category-selection-modal.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class CategorySelectionModalService {

    constructor(private cvApi: CVApiService) { }

    async loadData(moduleKey: string): Promise<CategorySetDTO> {
        let renderEndpoint: string;
        let categorySetDTO: CategorySetDTO;
        try {
            renderEndpoint = await this.cvApi.getModuleRenderEndPoint(moduleKey);
        }
        catch (error) {
            console.error("Failed to get module render endpoint for Cateory Selection Modal.");
            return;
        }
        try {
            const url = `/api/v2/dashboards/modules/categoryselection/${moduleKey}`;
            const response = await this.cvApi.get<CategorySetDTO>(url, renderEndpoint);

            if (response.status_code !== 200 || response.data == null)
                throw response;

            categorySetDTO = (response.data);
        }
        catch (error) {
            console.error("Failed getting Category Selection Modal data.");
            return;
        }
        
        //process category set to remove non-leaf entries and add rules to categories
        for (let i = categorySetDTO.categorySet.tree.categories.length - 1; i > -1; --i) {
            if (categorySetDTO.categorySet.tree.categories[i].type.toLowerCase().includes("group"))
                categorySetDTO.categorySet.tree.categories.splice(i, 1);
            else
                categorySetDTO.categorySet.tree.categories[i].categoryRules = categorySetDTO.categoryRules.filter((rule) =>
                    rule.node == categorySetDTO.categorySet.tree.categories[i].id);
        }
        categorySetDTO.categorySet.tree.categories.forEach((category) => {
            if (!category.categoryRules)
                category.categoryRules = [];
            category.categoryRules = categorySetDTO.categoryRules.filter((rule) => rule.node == category.id);
        });

        //process lang sets
        if (!(categorySetDTO.languageRules instanceof Map)) {
            let newMap = new Map<number, CategoryRule[]>();
            Object.entries<CategoryRule[]>(categorySetDTO.languageRules).forEach((kvPair) => {
                let id: number = parseInt(kvPair[0]);
                if (!newMap.has(id))
                    newMap.set(id, kvPair[1]);
            });
            categorySetDTO.languageRules = newMap;
        }

        let categoryRulesCheck = true;
        categorySetDTO.languageSets.forEach((ls) => {
            for (let i = ls.tree.categories.length - 1; i > -1; --i) {
                categoryRulesCheck = true;
                if (ls.tree.categories[i].type.toLowerCase().includes("group")) {
                    ls.tree.categories.splice(i, 1);
                    categoryRulesCheck = false;
                } else {
                    ls.tree.categories[i].categoryRules = categorySetDTO.languageRules.get(ls.id);
                }
                if (categoryRulesCheck) {
                    if (!ls?.tree?.categories[i]?.categoryRules)
                        ls.tree.categories[i].categoryRules = [];
                }
            }
        });

        return categorySetDTO;
    }

    async getInitialCategories(moduleKey: string): Promise<SelectedCategory[]> {
        let catSet = await this.loadData(moduleKey);
        let selCats: SelectedCategory[] = [];
        if (catSet?.categorySet?.tree?.categories != null)
            catSet.categorySet.tree.categories.forEach(category => {
                if (category.type.trim().toLowerCase() == "category")
                    selCats.push({ id: category.id, title: category.title });
            });
        return selCats;
    }
}
